import * as React from "react";
const SvgEmptyCourse = (props) => /* @__PURE__ */ React.createElement("svg", { width: 104, height: 72, viewBox: "8 22 104 72", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 86H106", style: {
  stroke: "rgb(var(--landing-stone-400, 200 192 178))"
}, strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("rect", { x: 22, y: 68, width: 76, height: 18, rx: 3, style: {
  fill: "rgb(var(--landing-white, 255 255 255))",
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M32 74H62M32 80H54", style: {
  stroke: "rgb(var(--landing-stone-400, 200 192 178))"
}, strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("rect", { x: 30, y: 50, width: 64, height: 18, rx: 3, style: {
  fill: "rgb(var(--landing-red, 192 57 43))",
  stroke: "rgb(var(--landing-red, 192 57 43))"
}, strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M40 59H66", style: {
  stroke: "rgb(var(--landing-white, 255 255 255))"
}, strokeWidth: 2, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("rect", { x: 26, y: 32, width: 70, height: 18, rx: 3, style: {
  fill: "rgb(var(--landing-white, 255 255 255))",
  stroke: "rgb(var(--landing-stone-600, 112 104 94))"
}, strokeWidth: 2 }), /* @__PURE__ */ React.createElement("path", { d: "M36 38H70M36 44H58", style: {
  stroke: "rgb(var(--landing-stone-400, 200 192 178))"
}, strokeWidth: 2, strokeLinecap: "round" }));
export default SvgEmptyCourse;
